import * as React from "react";
function SvgCheckboxTrue(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="#28bbbb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 9.8c.9.7 1.6 1.6 2.2 2.5C9.2 10 11.4 7 13 5"
      />
      <rect
        width={16}
        height={16}
        x={1}
        y={1}
        fill="none"
        stroke="#28bbbb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        rx={2}
        ry={2}
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCheckboxTrue);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
